module.exports = __webpack_public_path__ + "img/ape-constructor-checkmark.d548284b.svg";